import React, { useEffect, useRef, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from 'react-i18next';
import SimpleBar from "simplebar-react"

import { getVisibleMenu, matchPath } from './menues'

function SidebarContent() {
	const { t } = useTranslation();
	const ref = useRef();
	const location = useLocation();

	const [menu, setMenu] = useState(getVisibleMenu());

	useEffect(() => {
		setActiveMenu()
	}, [location]);

	function setActiveMenu() {
		const path = location.pathname;
		let updatedMenu = menu.map(item => {
			if (item.children) {
				const children = item.children.map(child => ({
					...child,
					active: matchPath(path, child.url)
				}));
				return {
					...item,
					active: children.some(child => child.active),
					children
				};
			}
			return {
				...item,
				active: matchPath(path, item.url)
			};
		});
		setMenu(updatedMenu);
	}

	function toggleDropdown(index, e) {
		e.preventDefault();
		const copy = [...menu];
		copy[index].active = !copy[index].active;
		setMenu(copy);
	}

	return (
		<SimpleBar style={{ maxHeight: "100%" }} ref={ref} className="sidebar-menu-scroll">
			<div id="sidebar-menu">
				<ul className="metismenu list-unstyled" id="side-menu">
					{menu.map((item, index) => (
						<li className={item.active ? "mm-active" : ""} key={index}>
							{item.children ? (
								<>
									<a
										href="#"
										className={"waves-effect d-flex justify-between align-items-center " + (item.active ? "active" : "")}
										onClick={(e) => toggleDropdown(index, e)}
										style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
									>
										<div>
											<i className={item.icon + " me-2"}></i>
											<span>{t(item.i18n)}</span>
										</div>
										<span>{item.active ? "▾" : "▸"}</span> {/* Qo‘lda chizilgan dropdown belgisi */}
									</a>
									<ul className="sub-menu" style={{ display: item.active ? "block" : "none" }}>
										{item.children.map((child, childIndex) => (
											<li key={childIndex}>
												<Link to={child.url} className={child.active ? "active" : ""}>
													{t(child.i18n)}
												</Link>
											</li>
										))}
									</ul>
								</>
							) : (
								<Link to={item.url} className={"waves-effect d-flex align-items-center " + (item.active ? "active" : "")}>
									<i className={item.icon + " me-2"}></i>
									<span>{t(item.i18n)}</span>
								</Link>
							)}
						</li>
					))}
				</ul>
			</div>
		</SimpleBar>
	)
}

export default SidebarContent
